import { render, staticRenderFns } from "./provider-orders-v2.modal.vue?vue&type=template&id=53b6468c&scoped=true"
import script from "./provider-orders-v2.modal.vue?vue&type=script&lang=js"
export * from "./provider-orders-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./provider-orders-v2.modal.vue?vue&type=style&index=0&id=53b6468c&prod&lang=scss&scoped=true"
import style1 from "./provider-orders-v2.modal.vue?vue&type=style&index=1&id=53b6468c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6468c",
  null
  
)

export default component.exports